<template>
  <div id="auth">
    <div class="container" style="align-items: center">
      <div class="content">
        <div class="sys_title"><img class="dw_logo mr-2" style="width: 50px" :src="sys_logo">{{sys_title}}</div>
        <div class="login">
          <a-row type="flex" align="middle">
            <a-col flex="0 0 378px">
              <img style="width: 100%" :src="$_c + 'img/p1.png'"/>
            </a-col>
            <a-col flex="auto">
              <div style="padding: 20px">
                <div class="logo mb-2"><img src="../../assets/logo2.svg"></div>
                <a-form :form="form" @submit="onSubmit">
                  <a-alert type="error" v-show="error" :message="error" showIcon style="margin-bottom: 24px;"/>
                  <a-form-item>
                    <a-input size="large" placeholder="账号" autofocus
                             v-decorator="['name', {rules: [{ required: true, message: '请输入账号', whitespace: true}]}]">
                      <a-icon slot="prefix" type="user"/>
                    </a-input>
                  </a-form-item>
                  <a-form-item>
                    <a-input size="large" placeholder="密码" type="password"
                             v-decorator="['password', {rules: [{ required: true, message: '请输入密码', whitespace: true}]}]">
                      <a-icon slot="prefix" type="lock"/>
                    </a-input>
                  </a-form-item>
                  <a-form-item>
                    <a-button :loading="logging" style="width: 100%;margin-top: 24px" size="large" htmlType="submit"
                              type="primary">登录
                    </a-button>
                  </a-form-item>
                </a-form>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="copyright">版权所有：{{sys_title}}</div>
    </div>
  </div>
</template>

<script>
import {JSEncrypt} from 'jsencrypt'
import { getSysTitle,getSysLogo } from '@/utils/auth'

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      rememberMe: false,
      logging: false,
      error: '',
      redirect: undefined,
      sys_title:'',
      sys_logo: ''
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  async created() {
    this.sys_title = await getSysTitle()
    this.sys_logo  = await getSysLogo()
  },
  methods: {
    onSubmit(e) {
      const that = this
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.logging = true
        let data = {
          account: this.form.getFieldValue('name'),
          password: that.encryptedData(this.form.getFieldValue('password')),
          rememberMe: this.rememberMe ? '1' : '0'
        }
        this.$store.dispatch('Login', data).then(() => {
          this.logging = false
          this.$router.push({path: this.redirect || '/dashboard/workplace'})
        }).catch((error) => {
          this.logging = false
          this.error = error.message
        })
      })
    },
    encryptedData(value) {
      let crypt = new JSEncrypt()
      crypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC02SHT0qJBIYaW+8RPhX4hLmUmNgKRe7eIXabz5PojDOUpmi4qLPcrbRcIcHPFTHmXH9lYQUaELmos5Juv0eglDG06kOHBKH4ipHiBdiIp/eQj4QFarXxVgu9Hn7DQv/bJITW0sHN8hiNJyERQFFI2GzjjyLjOFZu/vtqp56K7MQIDAQAB');
      return crypt.encrypt(value)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  height: 100vh;
  overflow: auto;
  justify-content: center;
  background-image: url(../../../public/img/bg.png);
  background-repeat: no-repeat;
  background-size: auto 1080px;
  background-position: center;

  .copyright {
    color: black;
    position: absolute;
    bottom: 10px;
    font-size: 16px;
  }
  .content {
    margin-top: 130px;
    width: 760px;
    height: 449px;
    border-radius: 10px;
    background-image: url(../../../public/img/bg2.png);
    padding-top: 20px;
    position: relative;
    .sys_title{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 32px;
      color: black;
      font-weight: bold;
      text-align: center;
      position: absolute;
      margin: auto;
      left: 0;
      right: 0;
      top: -170px
    }

    .login {
      width: 730px;
      height: 340px;
      margin: 0 auto;
      background: #fff;
      overflow: hidden;
      border-radius:16px;

      .logo {
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 258px;
        }
      }
      .title{
        text-align: center;
        font-size: 20px;
        font-weight: bold;
      }

      .icon {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
</style>
